import { apiFetchWeb } from "@/hooks/apiFetchWeb"

export const websiteOrderService = {
  getOrders: async (signal?: AbortSignal) =>
    apiFetchWeb("website/customer/orders", {
      signal,
    }),
  getOrder: async (orderId: number, signal?: AbortSignal) =>
    apiFetchWeb(`order/${orderId}`, {
      signal,
    }),
}
